/**
 * ユーザのアカウントステータス関連
 */
export namespace UserStatus {
  /** ユーザのロック状態:有効 */
  export const UNLOCKED = '有効'

  /** ユーザのロック状態:休止 */
  export const LOCKED = '休止'

  /** アクティベート前のユーザ(ロック状態がない) */
  export const TEMPORARY = '-'

  /** プルダウン選択肢:仮ユーザ */
  export const OPTION_TEMPORARY_USER = { value: 'temporary', label: '仮ユーザ' }

  /** プルダウン選択肢:本ユーザ */
  export const OPTION_ACTIVATED_USER = { value: 'active', label: '本ユーザ' }
}
